export function obterListaTipoIntermedio() {
  return (
    [
      { label: '1 - Por Conta Própria', value: 'CONTAPROPRIA' },
      { label: '2 - Por Conta e Ordem', value: 'CONTAORDEM' },
      { label: '3 - Encomenda', value: 'ENCOMENDA' },
    ]
  );
}
